import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DialogBase, T4RentalService } from 't4core';

@Component({
  selector: 't4-OrderServiceDialog',
  templateUrl: 'OrderServiceDialog.html',
})
export class OrderServiceDialog extends DialogBase implements OnInit {
  public description: string;
  public disableTrailer: boolean = false;
  public isLoading: boolean = false;
  public objectId: number;
  constructor(public dialogRef: MatDialogRef<OrderServiceDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService) {
    super("OrderServiceDialog");
    this.objectId = this.data.objectId;
  }

  ngOnInit(): void {

  }

  public async requestService() {
    var x = await this.UI.confirm("Turbo.Bookings.OrderServiceDialog.ConfirmRequestService", "Confirm service request", "Turbo.Bookings.OrderServiceDialog.msgConfirmRequestService", "Service orders will be chargeable to customer, and the exact cost will be determined based on the service.Do you wish to continue?");
    if (x) {
      this.isLoading = true;
      var result = await this.Api.post<boolean>("/Service/RequestService", null, {
        objectId: this.objectId,
        description: this.description,
        disableTrailer: this.disableTrailer
      });
      this.isLoading = false;
      if (result) {
        await this.UI.alert("Turbo.Bookings.OrderServiceDialog.successRequestService", "Service ordered successfully", "Turbo.Bookings.OrderServiceDialog.msgSuccessRequestService", "Your service order has been successfully placed. We will process it soon.", null, null, "/images/Icons/service-success.png");
        this.dialogRef.close(true);
      }
      else {
        await this.UI.alert("Turbo.Bookings.OrderServiceDialog.failedRequestService", "Service request failed", "Turbo.Bookings.OrderServiceDialog.msgFailedRequestService", "There was an issue with your service request. Please try again later.", null, null, "/images/Icons/service-error.png");
      }
    }
    else return;
  }

  public static async open(dialog: MatDialog, objectId: number): Promise<Boolean> {
    var dlg = dialog.open(OrderServiceDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "500px",
      data: {
        objectId: objectId
      }
    });

    return await dlg.afterClosed().toPromise();
  }

  public close() {
    this.dialogRef.close();
  }
}
